import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import Header from './Components/Header/Header';
import Education from './Components/Pages/Education';
import HealthCare from './Components/Pages/HealthCare';
import Marketing from './Components/Pages/Marketing';
import Sales from './Components/Pages/Sales';
import Footer from './Components/Footer/Footer';
import Home from './Components/Pages/Home';

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/header" element={<Header />} />
        <Route path="/" element={<Home />} />
        <Route path="/education-terms" element={<Education />} />
        <Route path="/health-care" element={<HealthCare />} />
        <Route path="/Marketing-Terms" element={<Marketing />} />
        <Route path="/Sales-Terms" element={<Sales />} />
        <Route path="/Footer-Terms" element={<Footer />} />
      </Routes>
    </Router>
  );
};

export default App;
